module.exports = __webpack_public_path__ + "img/Doom.6ed4bda3.png";